(() => {
  const boot = () => {
  if (window.lilpilloCollectionBound || !document.querySelector('[data-collection-mobile]')) return;
  window.lilpilloCollectionBound = true;
  const root = () => document.querySelector('[data-collection-mobile]');
  let desired = new URL(location.href), navigation = 0, requestController, draftController, draftVersion = 0, draftTimer;
  let opener, scrollStyle, compareSource;
  const pillowCount = (count) => `${count} ${String(count) === '1' ? 'pillow' : 'pillows'}`;
  const panels = () => [...root().querySelectorAll('dialog')];
  function closePanels() {
    draftVersion++; draftController?.abort(); clearTimeout(draftTimer);
    panels().forEach((panel) => { if (panel.open) panel.close(); });
    document.documentElement.style.overflow = scrollStyle || ''; 
  }
  function closePanel(panel) {
    if (panel?.open) panel.close();
  }
  function initializePanels() {
    panels().forEach((panel) => {
      panel.addEventListener('keydown', (event) => {
        if (event.key !== 'Tab') return;
        const items = [...panel.querySelectorAll('a[href],button,input,select,textarea,[tabindex]')].filter((item) => !item.disabled && item.tabIndex >= 0 && item.getClientRects().length);
        const first = items[0], last = items[items.length - 1];
        if (!first) { event.preventDefault(); return; }
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      });
      panel.addEventListener('close', () => {
        if (panels().some((other) => other.open)) return;
        document.documentElement.style.overflow = scrollStyle || '';
        draftVersion++; draftController?.abort(); clearTimeout(draftTimer);
        root().querySelector('[data-filter-form]')?.reset();
        if (opener?.isConnected) opener.focus({ preventScroll: true });
      });
      panel.addEventListener('click', (event) => { if (event.target === panel && (event.clientX < panel.getBoundingClientRect().left || event.clientX > panel.getBoundingClientRect().right || event.clientY < panel.getBoundingClientRect().top || event.clientY > panel.getBoundingClientRect().bottom)) closePanel(panel); });
    });
  }
  function openPanel(name, trigger) {
    closePanels(); opener = trigger; const panel = root().querySelector(`[data-panel="${name}"]`);
    if (!panel) return;
    scrollStyle = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden'; panel.showModal();
    if (name === 'filters') { root().querySelector('[data-filter-form]').reset(); updateDraft(); }
    if (name === 'compare') showCompare();
  }
  function cleaned(url) { const next = new URL(url, location.href); next.searchParams.delete('section_id'); next.searchParams.delete('sections'); return next; }
  function storeScroll() { history.replaceState({ ...history.state, lpcScroll: window.scrollY }, '', location.href); }
  async function getSection(url, section, signal) {
    const target = new URL(url); target.searchParams.set('section_id', section);
    if (desired.searchParams.has('preview_theme_id')) target.searchParams.set('preview_theme_id', desired.searchParams.get('preview_theme_id'));
    const response = await fetch(target, { signal: signal || AbortSignal.timeout(15000) });
    if (!response.ok) throw new Error('The catalogue could not be refreshed. Please try again.');
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    // DOMParser parses with scripting disabled; keep no-JS fallback styles inert after insertion.
    doc.querySelectorAll('noscript').forEach((element) => element.remove());
    return doc;
  }
  async function navigate(url, { pop = false, scroll = null, heightChoice = null } = {}) {
    const next = cleaned(url); const sequence = ++navigation;
    requestController?.abort(); requestController = new AbortController(); desired = next;
    root().querySelector('[data-collection-status]').textContent = 'Updating pillows…';
    try {
      const doc = await getSection(next, root().dataset.section, requestController.signal);
      if (sequence !== navigation) return;
      const candidate = doc.querySelector('[data-collection-mobile]');
      if (!candidate) throw new Error('The catalogue could not be refreshed. Please reload this page.');
      closePanels();
      if (!pop) { storeScroll(); history.pushState({ lpcScroll: window.scrollY }, '', next); }
      root().replaceWith(candidate); initializePanels();
      if (heightChoice) showHeightChoice(heightChoice.height, heightChoice.sizes);
      if (scroll !== null) window.scrollTo(0, scroll);
      root().querySelector('[data-collection-status]').textContent = `${pillowCount(candidate.dataset.count)} shown.`;
    } catch (error) {
      if (error.name === 'AbortError' || sequence !== navigation) return;
      desired = new URL(location.href); root().querySelector('[data-collection-status]').textContent = error.message;
    }
  }
  function sizeURL(sizes) {
    const url = new URL(desired); const key = root().dataset.sizeParam;
    if (!key) return url;
    url.searchParams.delete(key); sizes.forEach((size) => url.searchParams.append(key, size)); url.searchParams.delete('page'); return url;
  }
  function showHeightChoice(height, sizes) {
    const state = root().querySelector('[data-size-state]'); if (!state) return;
    state.textContent = sizes.length > 1 ? `For ${height} cm, compare ${sizes.join(' and ')}.` : `For ${height} cm, start with ${sizes[0]}.`;
  }
  function filterURL(form) {
    const url = new URL(desired);
    [...url.searchParams.keys()].filter((key) => key.startsWith('filter.') || key === 'sort_by' || key === 'page').forEach((key) => url.searchParams.delete(key));
    for (const [key, value] of new FormData(form)) if (String(value).trim() !== '') url.searchParams.append(key, value);
    return url;
  }
  async function updateDraft() {
    const version = ++draftVersion; draftController?.abort(); draftController = new AbortController();
    const form = root().querySelector('[data-filter-form]'); const button = form.querySelector('[data-apply]');
    button.textContent = 'Show pillows'; form.querySelector('[data-draft-status]').textContent = 'Checking matching pillows…';
    try {
      const doc = await getSection(filterURL(form), root().dataset.section, draftController.signal);
      if (version !== draftVersion) return;
      const count = doc.querySelector('[data-collection-mobile]')?.dataset.count;
      if (count === undefined) throw new Error();
      button.textContent = `Show ${pillowCount(count)}`; form.querySelector('[data-draft-status]').textContent = '';
    } catch (error) { if (error.name !== 'AbortError' && version === draftVersion) form.querySelector('[data-draft-status]').textContent = 'The count is unavailable. Apply to load matching pillows.'; }
  }
  async function showCompare() {
    const content = root().querySelector('[data-compare-content]'); content.textContent = 'Loading pillow types…';
    try {
      if (!compareSource) {
        const url = new URL(root().dataset.collectionUrl, location.origin);
        const doc = await getSection(url, 'lp-pillow-comparison'); compareSource = doc.querySelector('[data-comparison-source]');
        if (!compareSource) throw new Error();
      }
      const selected = desired.searchParams.getAll(root().dataset.sizeParam);
      root().querySelector('[data-compare-size]').textContent = selected.length ? `Comparing ${selected.join(' and ')}. Other sizes are labelled explicitly.` : 'All sizes. Choose a family, then its size.';
      content.replaceChildren();
      const source = [...compareSource.querySelectorAll('[data-compare-product]')];
      const families = [...new Set(source.map((item) => item.dataset.family))];
      families.forEach((family) => {
        const products = source.filter((item) => item.dataset.family === family);
        const matching = selected.length ? products.filter((item) => selected.includes(item.dataset.size)) : products;
        const block = (matching[0] || products[0]).cloneNode(true);
        block.querySelectorAll('[data-compare-option]').forEach((option) => option.remove());
        if (!matching.length) { const notice = document.createElement('p'); notice.textContent = `${[...new Set(products.map((p) => p.dataset.size))].join(' / ')} only — not available in ${selected.join(' or ')}.`; block.append(notice); }
        (matching.length ? matching : products).forEach((item) => block.append(item.querySelector('[data-compare-option]').cloneNode(true)));
        content.append(block);
      });
    } catch (_) { content.textContent = 'Comparison could not load. Product pages still have the full materials, care and size details.'; }
  }
  async function refreshDrawer() {
    const doc = await getSection(new URL(root().dataset.cartUrl, location.origin), 'lp-collection-cart');
    const body = doc.querySelector('[data-lp-cart]'); if (!body) throw new Error('Basket display unavailable.');
    const content = root().querySelector('[data-cart-content]'); content.replaceChildren(body);
    window.LilPilloCart.init(body, { onRefresh: refreshDrawer });
    root().querySelector('[data-drawer-status]').textContent = '';
  }
  async function add(form) {
    const button = form.querySelector('button'); if (button.disabled || window.LilPilloCart.pending) return;
    const status = form.closest('[data-collection-card]').querySelector('[data-add-status]');
    const original = button.innerHTML; button.disabled = true; button.setAttribute('aria-busy', 'true'); button.textContent = 'Adding…'; status.textContent = '';
    let added = false, uncertain = false;
    try {
      await window.LilPilloCart.add(form); added = true;
      button.textContent = 'Added'; status.textContent = 'Added to your bag.';
      openPanel('cart', button);
      await window.LilPilloCart.refresh(); await refreshDrawer();
    } catch (error) {
      if (added) {
        status.textContent = 'Added to your bag. The basket display could not refresh; your item has not been added again.';
        const drawerStatus = root().querySelector('[data-drawer-status]'); drawerStatus.textContent = 'Your item was added. Refresh the display or open the full basket.';
        const retry = document.createElement('button'); retry.type = 'button'; retry.dataset.refreshCart = ''; retry.textContent = 'Refresh basket display'; drawerStatus.append(retry);
      } else {
        uncertain = !error.rejected;
        status.textContent = uncertain ? 'We could not confirm whether this item was added. Check your bag before trying again.' : error.message;
        if (uncertain) { const link = document.createElement('a'); link.href = root().dataset.cartUrl; link.textContent = ' Check bag'; status.append(link); }
      }
    } finally {
      button.removeAttribute('aria-busy'); button.disabled = uncertain;
      button.innerHTML = uncertain ? 'Check bag first' : original;
    }
  }
  document.addEventListener('click', (event) => {
    const target = event.target.closest('a,button'); if (!target) return;
    if (target.closest('[data-collection-mobile]')) {
      if (target.matches('[data-open]')) { event.preventDefault(); openPanel(target.dataset.open, target); }
      else if (target.matches('[data-close]')) { closePanel(target.closest('dialog')); }
      else if (target.matches('[data-size]')) { event.preventDefault(); navigate(sizeURL(target.dataset.size ? [target.dataset.size] : [])); }
      else if (target.matches('[data-navigate],.lpc-pagination a,[data-apply-sizes]')) { event.preventDefault(); navigate(target.href); }
      else if (target.matches('[data-clear-filters]')) {
        const form = target.closest('form'); form.querySelectorAll('input[name^="filter."]').forEach((input) => { if (input.type === 'checkbox') input.checked = false; else if (input.name !== root().dataset.sizeParam) input.value = ''; }); updateDraft();
      } else if (target.matches('[data-refresh-cart]')) {
        target.disabled = true; window.LilPilloCart.refresh().then(refreshDrawer).catch(() => { target.disabled = false; });
      }
    }
    if (target.matches('a[href*="/products/"]')) storeScroll();
  });
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (form.matches('[data-filter-form]')) { event.preventDefault(); navigate(filterURL(form)); }
    if (form.matches('[data-collection-add]')) { event.preventDefault(); add(form); }
    if (form.matches('[data-height-form]') && form.closest('[data-collection-mobile]')) {
      event.preventDefault(); const input = form.querySelector('[name=height]'); const result = window.LilPilloSizes.recommend(input.value);
      const output = root().querySelector('[data-finder-result]'); output.replaceChildren(); input.setAttribute('aria-invalid', String(Boolean(result.error)));
      if (result.error) { output.textContent = result.error; return; }
      const names = { mini: 'Mini', full: 'Full Size', large: 'Large' }; const sizes = result.sizes.map((size) => names[size]);
      if (!sizes.length) { output.textContent = 'There is no size recommendation for this height in this guide. Check the height or close this window to browse all pillows.'; return; }
      if (!root().dataset.sizeParam) { output.textContent = 'The size category is unavailable right now. Close this window to browse all pillows.'; return; }
      closePanel(form.closest('dialog'));
      navigate(sizeURL(sizes), { heightChoice: { height: String(Number(input.value)), sizes } });
    }
  });
  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-sort]')) { const url = new URL(desired); url.searchParams.set('sort_by', event.target.value); url.searchParams.delete('page'); navigate(url); }
    if (event.target.closest('[data-filter-form]')) { clearTimeout(draftTimer); draftTimer = setTimeout(updateDraft, 150); }
  });
  document.addEventListener('input', (event) => { if (event.target.matches('#lpc-height')) { event.target.removeAttribute('aria-invalid'); root().querySelector('[data-finder-result]').textContent = ''; } });
  window.addEventListener('popstate', (event) => { desired = new URL(location.href); navigate(desired, { pop: true, scroll: event.state?.lpcScroll ?? 0 }); });
  window.addEventListener('pageshow', () => { if (history.state?.lpcScroll !== undefined) window.scrollTo(0, history.state.lpcScroll); });
  initializePanels();
  document.addEventListener('shopify:section:load', initializePanels);
  };
  boot();
})();
